
export type StreamingInfoResponseQualitiesItem = {
  /** 비트레이트 (kbps) */
  bitrate?: number;
  height?: number;
  resolution?: string;
  width?: number;
};
